

















import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  HsabSsoDestination,
} from "@/shared/types";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
@Component({
  components: {
    SsoDeepLink
  }
})
export default class FeeScheduleAndRatesDeepLink extends Vue {
  get hsabFeeScheduleAndRatesLocation () {
    return HsabSsoDestination.FeeScheduleAndRates;
  }
}
